<template>
  <div class="customer-house-log">
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="业户信息完整度" name="CustomerCompleteness" v-if="ERP.isPermission(3007008)">
        <CustomerCompleteness v-if="activeName==='CustomerCompleteness'" />
      </el-tab-pane>
      <el-tab-pane label="业户日志" name="CustomerLog" v-if="ERP.isPermission(3007001)">
        <CustomerLog v-if="activeName==='CustomerLog'" />
      </el-tab-pane>
      <el-tab-pane label="业户房产" name="CustomerHouseLog" v-if="ERP.isPermission(3007002)">
        <CustomerHouseLog v-if="activeName==='CustomerHouseLog'" />
      </el-tab-pane>
      <el-tab-pane label="房态日志" name="RoomStatusLog" v-if="ERP.isPermission(3007003)">
        <RoomStatusLog v-if="activeName==='RoomStatusLog'" />
      </el-tab-pane>
      <el-tab-pane label="业户跨项目异常" name="CrossCustomerWarning" v-if="ERP.isPermission(3007004)">
        <CrossCustomerWarning v-if="activeName==='CrossCustomerWarning'" />
      </el-tab-pane>
      <el-tab-pane label="房产多业主异常" name="HouseCustomerWarning" v-if="ERP.isPermission(3007005)">
        <HouseCustomerWarning v-if="activeName==='HouseCustomerWarning'" />
      </el-tab-pane>
      <el-tab-pane label="项目业户房产关系" name="ProjectHouseCustomer" v-if="ERP.isPermission(3007006)">
        <ProjectHouseCustomer v-if="activeName==='ProjectHouseCustomer'" />
      </el-tab-pane>
      <el-tab-pane label="项目房产房态" name="ProjectHouseStatus" v-if="ERP.isPermission(3007007)">
        <ProjectHouseStatus v-if="activeName==='ProjectHouseStatus'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CustomerLog from "./components/CustomerLog";
import CustomerHouseLog from "./components/CustomerHouseLog";
import RoomStatusLog from "./components/RoomStatusLog";
import CrossCustomerWarning from "./components/CrossCustomerWarning";
import HouseCustomerWarning from "./components/HouseCustomerWarning";
import ProjectHouseCustomer from "./components/ProjectHouseCustomer";
import ProjectHouseStatus from "./components/ProjectHouseStatus";
import CustomerCompleteness from "./components/CustomerCompleteness";
export default {
  name: "CustomerHouseLogMain",
  components: {
    CustomerCompleteness,
    ProjectHouseStatus,
    ProjectHouseCustomer,
    HouseCustomerWarning, CrossCustomerWarning, RoomStatusLog, CustomerHouseLog, CustomerLog},
  data() {
    return {
      activeName: "CustomerLog"
    };
  },
}
</script>

<style lang="scss" scoped>
.customer-house-log {
  //padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/customer-log/CustomerHouseLogMain.vue